/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Line_Col_MaterialInputs */

const vi_stocktake_line_col_material = /** @type {(inputs: Stocktake_Line_Col_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vật tư/SP`)
};

/**

* @param {Stocktake_Line_Col_MaterialInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_line_col_material = /** @type {((inputs?: Stocktake_Line_Col_MaterialInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Line_Col_MaterialInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_line_col_material(inputs)
});